import React, { useState, useCallback, useEffect } from 'react'
import { useLocationContext, useLocationDispatch } from '../../../../../../../../contexts/location.context'
import { getCityDetails, GTM } from '../../../../../../../../helpers'
import useUpdateCartItemsShippingDetails from '../../../../../../../../helpers/updateCartItemsShippingDetails'
import AvailabilityWmo from './AvailabilityWmo'
import { useEconomyEnabled } from '../../../../../../../../hooks/useEconomyFlag'
import {
  useUnfoldedShippingCookie,
  useUnfoldedShippingEnabled,
} from '../../../../../../../../hooks/useUnfoldedShipping'
import {
  useStaticProps,
} from '../../../../../../../../contexts/staticProps.context'

const Availability = props => {
  const {
    data, showPopup, shouldShowPopup, isLastMile = false,
  } = props
  const { shippingOption } = data

  const [showLoader, shouldShowLoader] = useState(false)

  const locationState = useLocationContext()
  const setLocationData = useLocationDispatch()
  const updateCartItemsShippingDetails = useUpdateCartItemsShippingDetails()

  const storedZipCode = (locationState || {}).postalCode
  const storedCity = (locationState || {}).city

  const [zipCode, setZipCode] = useState(storedZipCode || '')
  const [zipCodeError, setZipCodeError] = useState('')

  useEffect(() => {
    if (showPopup) {
      setZipCode(storedZipCode || '')
      setZipCodeError('')
    }
  }, [showPopup, storedZipCode])

  const handleChangeZip = useCallback(
    event => {
      const { value } = event.target
      if (zipCodeError !== '' && value === '') setZipCodeError('')

      setZipCode(value)
    },
    [setZipCode, zipCodeError, setZipCodeError],
  )

  const isValidZip = useCallback(
    () => /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipCode),
    [zipCode],
  )

  const handleSubmitZip = useCallback(
    async () => {
      if (!isValidZip()) {
        setZipCodeError('Please enter a valid U.S ZIP Code')
        return
      }

      shouldShowLoader(true)
      GTM.shippingEtaModalCtaGTM('cart')
      try {
        const res = await getCityDetails(zipCode)
        setLocationData({
          postalCode: zipCode,
          city: res.city,
          state: res.region,
        })
        updateCartItemsShippingDetails({
          location: {
            zipcode: zipCode,
            city: res.city,
            state: res.region,
          },
        })
        setZipCodeError('')
      } catch (error) {
        setZipCodeError('Please enter a valid U.S ZIP Code')
      }
      shouldShowLoader(false)
    },
    [isValidZip, zipCode, setLocationData, updateCartItemsShippingDetails],
  )

  const isEconomyShippingEnabled = useEconomyEnabled()

  const staticProps = useStaticProps()
  const unfoldedShippingConfig = staticProps?.unfoldedShipping || {}
  const isUnfoldedShippingEnabled = useUnfoldedShippingEnabled()
  const unfoldedShippingVariant = useUnfoldedShippingCookie()
  let isProductValidForUnfoldedShipping = (data?.product?.part?.name || '').toLowerCase().includes('bumper')
  // If the product is valid for unfolded shipping with part name containing bumper,
  // double check if the shipping options include Ground_unfolded
  if (isProductValidForUnfoldedShipping) {
    const hasGroundUnfoldedOption = (shippingOption?.options || []).find(option => option.method === 'Ground_unfolded')
    isProductValidForUnfoldedShipping = Boolean(hasGroundUnfoldedOption)
  }

  return (
    <AvailabilityWmo
      shippingOption={shippingOption}
      handleSubmitZip={handleSubmitZip}
      handleChangeZip={handleChangeZip}
      zipCodeError={zipCodeError}
      zipCode={zipCode}
      showLoader={showLoader}
      storedZipCode={storedZipCode}
      storedCity={storedCity}
      showPopup={showPopup}
      shouldShowPopup={shouldShowPopup}
      isEconomyShippingEnabled={isEconomyShippingEnabled}
      unfoldedShippingConfig={unfoldedShippingConfig}
      isUnfoldedShippingEnabled={isUnfoldedShippingEnabled}
      unfoldedShippingVariant={unfoldedShippingVariant}
      isProductValidForUnfoldedShipping={isProductValidForUnfoldedShipping}
      isLastMile={isLastMile}
    />
  )
}

export default Availability
